import { Skeleton } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import helpmob from "../../../assets/images/helpmob.svg";
import srchic from "../../../assets/images/srchic.svg";
import robot from "../../../assets/images/robot.png";
import airplane from "../../../assets/images/airplane.png";
import { BundleCard } from "../../../components";
import MainLoader from "../../../components/mainLoader";
import Pagination from "../../../components/pagination";
import { GetGeoLocations } from "../../../utils/GetGeoLocation";
import { BUNDLE_TYPE } from "../../../utils/constants";
import { addOrder, getDocumentStatus } from "../../checkout/api";
import { Bundle } from "../../esim/interface";
import { getCompatibleDevice } from "../../packageOption/api";
import { getCountries, getRegions, getbundles } from "../api";
import styles from "../styles/home.module.css";
import { STRINGS } from "../../../constants/strings";
import guide from "../../../assets/images/Guide.png";
import forandroid from "../../../assets/images/for_android.png";
import forios from "../../../assets/images/for_ios.png";
import Futuristic from "../../../assets/images/Futuristic.png";
import redefined from "../../../assets/images/redefined.png";
import Sustainable from "../../../assets/images/Sustainable.png";
import eSIM from "../../../assets/images/eSim.png";
import softstar from "../../../assets/images/soft_star.png";
import londoneye from "../../../assets/images/londoneye.webp";
import amalficoast from "../../../assets/images/amalficoast.webp";
import MerlionPark from "../../../assets/images/MerlionPark.jpg";
import eiffeltower from "../../../assets/images/eiffeltower.jpg";
import Halongbay from "../../../assets/images/Halongbay.jpg";
import Lakezurich from "../../../assets/images/Lakezurich.jpg";
import { debounce } from "lodash";
import travelmate from "../../../assets/images/mentravel.png";
import inner from "../../../assets/images/inner.png";
import outer from "../../../assets/images/outerRing.png";
interface Coordinates {
  latitude: number;
  longitude: number;
  name: string;
}

const EsimDestination: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const eSimPage = location.pathname.split("/").includes("esim-list");

  const { latitude, longitude } = useSelector((state: any) => state.location);

  const [activeTab, setActiveTab] = useState<number>(BUNDLE_TYPE.LOCAL);

  const [bundles, setBundles] = useState<Bundle[]>([]);
  const [getDatas, setGetDatas] = useState<any>();
  const [getMobDatas, setGetMobDatas] = useState<any>();
  const [loader, setLoader] = useState<boolean>(true);
  const currency = useSelector((state: any) => state?.getCurrency?.currency);
  const [welcomeModalShow, setWelcomeModalShow] = useState(false);
  const [country, setCountry] = useState<string>("India");
  const loadmore: boolean = true;
  const [searchVal, setSearchVal] = useState<any>({
    search: "",
    submit: false,
  });
  const [selectedTab, setSelectedTab] = useState("ConnectAI");
  const [countriesData, setCountriesData] = useState<any>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [geoLocationData, setGeoLocationData] = useState<any>({
    latitude: 0,
    longitude: 0,
  });
  const [paymentGateway, setPaymentGateway] = useState<any>(null);
  const [geoLocationErr, setGeoLocationErr] = useState<boolean>(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showSomeDropdown, setShowSomeDropdown] = useState<any>({
    installation: false,
    deviceCompatibility: false,
  });
  const [deviceName, setDeviceName] = useState("");

  const [getLoader, setGetLoader] = useState<boolean>(false);
  const [selectedPlatform, setSelectedPlatform] = useState<"ios" | "android">(
    "ios"
  );

  const handleResize = debounce(() => {
    setIsMobile(window.innerWidth <= 768);
  }, 300);

  // useEffect(() => {
  //   window.addEventListener("resize", handleResize);
  //   if (isMobile) setActiveTab(1);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, [isMobile]);
  useEffect(() => {
    if (isMobile) {
      setActiveTab(1);
    }
  }, [isMobile]);
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const showWelcomeModalShow = (val: any) => {
    setWelcomeModalShow(val);
  };

  const pageRecords = eSimPage ? 12 : 12;

  useEffect(() => {
    let currentTime: any = new Date();

    const hasPopupBeenShown = localStorage.getItem("showWelcomeModal");

    if (!hasPopupBeenShown || currentTime.getTime() > hasPopupBeenShown) {
      currentTime.setHours(currentTime.getHours() + 12);

      localStorage.setItem("showWelcomeModal", currentTime.getTime());

      showWelcomeModalShow("show");
    }
  }, []);

  useEffect(() => {
    setLoader(true);
    if (activeTab === BUNDLE_TYPE.POPULAR) {
      GetGeoLocations()
        .then((data: any) => {
          setGeoLocationErr(false);
          setGeoLocationData(data);

          const query: any = {
            page: currentPage,
            limit: pageRecords,
          };

          if (data.latitude || data.longitude) {
            query.lat = data?.latitude;
            query.long = data?.longitude;
          }

          if (searchVal.search) query.searchString = searchVal?.search;

          getCountries(query, "667000f74e37cd362882386e")
            .then((res: any) => {
              setLoader(false);
              if (currentPage === 1) {
                const data = {
                  ...res?.data,
                  countries1: res?.data?.countries,
                };
                setGetDatas(data);
              } else {
                setGetDatas((pre: any) => ({
                  ...pre,
                  countries: [...pre.countries, ...res?.data?.countries],
                }));
              }
            })
            .catch((error) => {
              console.log(error);
              setLoader(false);
            });
        })
        .catch((error) => {
          const query: any = {
            page: currentPage,
            limit: pageRecords,
            isPopular: true,
          };
          if (searchVal.search) query.searchString = searchVal?.search;

          getCountries(query, "667000f74e37cd362882386e")
            .then((res: any) => {
              setLoader(false);
              if (currentPage === 1) {
                setGetDatas(res?.data);
              } else {
                setGetDatas((pre: any) => ({
                  ...pre,
                  countries: [...pre.countries, ...res?.data?.countries],
                }));
              }
            })
            .catch((error) => {
              console.log(error);
              setLoader(false);
            });
          // setGeoLocationErr(true);
          // setGetDatas([]);
          // console.log("Error getting location:", error);
          // setLoader(false);
        });
    } else if (activeTab === BUNDLE_TYPE.LOCAL) {
      const query: any = {
        page: currentPage,
        limit: pageRecords,
      };

      if (searchVal.search) query.searchString = searchVal?.search;

      getCountries(query, "667000f74e37cd362882386e")
        .then((res: any) => {
          setLoader(false);
          if (currentPage === 1) {
            const data = {
              ...res?.data,
              countries1: res?.data?.countries,
            };

            setGetDatas(data);
            // setGetDatas(res?.data);
          } else {
            setGetDatas((pre: any) => ({
              ...pre,
              countries: [...pre.countries, ...res?.data?.countries],
            }));
          }
        })
        .catch((error) => {
          console.log(error);
          setLoader(false);
        });
    } else if (activeTab === BUNDLE_TYPE.MULTIVERSE) {
      const query: any = {
        page: currentPage,
        limit: pageRecords,
      };
      if (searchVal.search) query.search = searchVal?.search;
      getRegions(query, "667000f74e37cd362882386e")
        .then((res: any) => {
          setLoader(false);
          setGetDatas(res?.data);
        })
        .catch((error) => {
          console.log(error);
          setLoader(false);
        });
    }
  }, [activeTab, currency, currentPage]);

  const handleSearchSubmit = () => {
    setGeoLocationData({ latitude: 0, longitude: 0 });
    setCurrentPage(1);
    setSearchVal({
      ...searchVal,
      submit: !searchVal.submit,
    });
    setCountriesData("");
  };
  const countryAliases: Record<string, string> = {
    uk: "United Kingdom",
    usa: "United States",
    us: "United States",
    uae: "United Arab Emirates",
    dubai: "United Arab Emirates",
  };

  const debouncedSearch = useRef(
    debounce(async (searchTerm: string, aliasMatch: string | undefined) => {
      if (searchTerm) {
        try {
          const res: any = await getCountries(
            { searchString: aliasMatch || searchTerm },
            "667000f74e37cd362882386e"
          );

          const countries = res?.data?.countries || [];

          // const exactMatchFound = countries.some(
          //   (country: any) =>
          //     country.name.toLowerCase() === searchTerm.toLowerCase() ||
          //     country.aliases?.some(
          //       (alias: string) => alias.toLowerCase() === searchTerm.toLowerCase()
          //     )
          // );

          setCountriesData(countries ?? []);
        } catch (error) {
          console.error(error, "search");

          setCountriesData([]);
        } finally {
          setLoader(false);
        }
      } else {
        setCountriesData([]);
        setLoader(false);
      }
    }, 300) // 300ms debounce delay
  ).current;

  const handleSearchCountries = useCallback(
    (e: any) => {
      const searchValue = e.target.value.toLowerCase();
      const trimmedSearch = searchValue.trim();
      const aliasMatch = countryAliases[trimmedSearch];
      const searchTerm = aliasMatch || trimmedSearch;

      setSearchVal((prev: any) => ({
        ...prev,
        search: searchValue,
        // submit: isMobile ? !prev.submit : prev.submit, // toggle only for mobile
      }));

      if (!searchTerm || (!aliasMatch && searchTerm.length <= 2)) {
        setCountriesData([]);
        setLoader(false);
        return;
      }

      setLoader(true);
      debouncedSearch(searchTerm, aliasMatch);
    },
    [isMobile, searchVal.submit, countryAliases]
  );

  // const handleSearchCountries = async (e: any) => {
  //   setLoader(true);
  //   const searchValue = e.target.value.toLowerCase();
  //   const trimmedSearch = searchValue.trim();

  //   // Check for alias match
  //   const aliasMatch = countryAliases[trimmedSearch];
  //   const searchTerm = aliasMatch || searchValue;

  //   setSearchVal({
  //     submit: isMobile ? !searchVal.submit : false,
  //     search: searchValue, // Keep original input value for display
  //   });
  //   // Handle empty input
  //   //  if (!searchValue.trim()) {
  //   //   setCountriesData([]);
  //   //   setSearchVal({ submit: false, search: "" }); // Reset search value
  //   //   setLoader(false);
  //   //   return;
  //   // }
  //   // Don't return early for alias matches
  //   if (!aliasMatch && searchValue.length <= 2) {
  //     setCountriesData([]);
  //     setLoader(false);
  //     return;
  //   }

  //   if (!searchValue) {
  //     setCountriesData([]);
  //     setLoader(false);
  //     return;
  //   }

  //   if (searchValue && !isMobile) {
  //     // Use the aliasMatch if available, otherwise use the trimmed search value
  //     getCountries(
  //       { searchString: aliasMatch || searchValue.trim() },
  //       "667000f74e37cd362882386e"
  //     )
  //       .then((res: any) => {
  //         setCountriesData(res?.data?.countries);
  //         setLoader(false);
  //       })
  //       .catch((error) => {
  //         console.log(error, "search");
  //         setLoader(false);
  //       });
  //   }
  // };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handelCompatibleDevice = () => {
    if (!deviceName) return toast.error("Please enter device name");
    getCompatibleDevice({ deviceName })
      .then((res) => {
        res?.statusCode === 200
          ? toast.success(res?.data?.deviceMessage)
          : toast.error("Something went wrong!!!");
      })
      .catch((error) => {
        setLoader(false);
        toast.error("Something went wrong!!!");
      });
  };

  // const createOrder = (countryName: string) => {
  //   setGetLoader(true);

  //   let paymentGatewayType: string | undefined; // Declare outside to access later

  //   GetGeoLocations()
  //     .then((geoData: any) => {
  //       return getDocumentStatus(geoData).then((resGeo: any) => {
  //         paymentGatewayType = resGeo?.data?.paymentGatewayType; // Store value for later use
  //         setPaymentGateway(paymentGatewayType);

  //         const query: any = {
  //           search: countryName,
  //           ...(geoData?.latitude && geoData?.longitude && {
  //             lat: geoData.latitude,
  //             long: geoData.longitude,
  //           }),
  //         };

  //         return getbundles(query).then((res: any) => {
  //           const orderPayload: any = {
  //             bundleId: res?.data?.bundles[0]?._id,
  //             quantity: 1,
  //             ...(geoData?.latitude && geoData?.longitude && {
  //               lat: geoData.latitude,
  //               long: geoData.longitude,
  //             }),
  //           };

  //           window.localStorage.setItem("countryName", countryName);
  //           window.localStorage.setItem("showDocuments", resGeo?.data?.showDocuments);

  //           return addOrder(orderPayload);
  //         });
  //       });
  //     })
  //     .then((Response: any) => {
  //       navigate(`/checkout/${Response?.data?.orderId}/?paymentGateway=${paymentGatewayType}`);
  //       setGetLoader(false);
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       setGetLoader(false);
  //       // Swal.fire("Please enable your location service!");
  //       getDocumentStatus().then((resGeo: any) => {
  //         paymentGatewayType = resGeo?.data?.paymentGatewayType; // Store value for later use
  //         setPaymentGateway(paymentGatewayType);

  //         const query: any = {
  //           search: countryName,

  //         };

  //         return getbundles(query).then((res: any) => {
  //           const orderPayload: any = {
  //             bundleId: res?.data?.bundles[0]?._id,
  //             quantity: 1,

  //           };

  //           window.localStorage.setItem("countryName", countryName);
  //           window.localStorage.setItem("showDocuments", resGeo?.data?.showDocuments);

  //           return addOrder(orderPayload);
  //         });
  //       }).then((Response: any) => {
  //         navigate(`/checkout/${Response?.data?.orderId}/?paymentGateway=${paymentGatewayType}`);
  //         setGetLoader(false);
  //       });
  //     });
  // };
  // const createOrder = (countryName: string) => {
  //   setGetLoader(true);

  //   let paymentGatewayType: string | undefined; // Declare outside to access later

  //   GetGeoLocations()
  //     .then((geoData: any) => {
  //       return getDocumentStatus(geoData).then((resGeo: any) => {
  //         paymentGatewayType = resGeo?.data?.paymentGatewayType; // Store value for later use
  //         setPaymentGateway(paymentGatewayType);

  //         const query: any = {
  //           search: countryName,
  //           ...(geoData?.latitude && geoData?.longitude && {
  //             lat: geoData.latitude,
  //             long: geoData.longitude,
  //           }),
  //         };

  //         return getbundles(query).then((res: any) => {
  //           window.localStorage.setItem("countryName", countryName);
  //           window.localStorage.setItem("showDocuments", resGeo?.data?.showDocuments);

  //           return res;
  //         });
  //       });
  //     })
  //     .then(() => {
  //       navigate(`/${encodeURIComponent(countryName)}`);
  //       setGetLoader(false);
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       setGetLoader(false);

  //       getDocumentStatus().then((resGeo: any) => {
  //         paymentGatewayType = resGeo?.data?.paymentGatewayType; // Store value for later use
  //         setPaymentGateway(paymentGatewayType);

  //         const query: any = { search: countryName };

  //         return getbundles(query).then((res: any) => {
  //           window.localStorage.setItem("countryName", countryName);
  //           window.localStorage.setItem("showDocuments", resGeo?.data?.showDocuments);

  //           return res;
  //         });
  //       }).then(() => {
  //         navigate(`/${encodeURIComponent(countryName)}`);;
  //         setGetLoader(false);
  //       });
  //     });
  // };
  const createOrder = (countryName: string) => {
    setGetLoader(true);

    let paymentGatewayType: string | undefined; // Declare outside to access later

    // Retrieve lat & long from localStorage

    // this is commented bcz we are getting latitude and logitude from the store _

    // const latitude = localStorage.getItem("latitude");
    // const longitude = localStorage.getItem("longitude");

    const geoData = {
      latitude: latitude ? parseFloat(latitude) : null,
      longitude: longitude ? parseFloat(longitude) : null,
    };

    getDocumentStatus(geoData)
      .then((resGeo: any) => {
        paymentGatewayType = resGeo?.data?.paymentGatewayType;
        setPaymentGateway(paymentGatewayType);

        const query: any = {
          search: countryName,
          ...(geoData.latitude &&
            geoData.longitude && {
              lat: geoData.latitude,
              long: geoData.longitude,
            }),
        };

        return getbundles(query, "667000f74e37cd362882386e").then(
          (res: any) => {
            localStorage.setItem("countryName", countryName);
            localStorage.setItem("showDocuments", resGeo?.data?.showDocuments);

            return res;
          }
        );
      })
      .then(() => {
        navigate(`/${encodeURIComponent(countryName)}`);
        setGetLoader(false);
      })
      .catch((error) => {
        console.error(error);
        setGetLoader(false);

        getDocumentStatus()
          .then((resGeo: any) => {
            paymentGatewayType = resGeo?.data?.paymentGatewayType;
            setPaymentGateway(paymentGatewayType);

            const query: any = { search: countryName };

            return getbundles(query, "667000f74e37cd362882386e").then(
              (res: any) => {
                localStorage.setItem("countryName", countryName);
                localStorage.setItem(
                  "showDocuments",
                  resGeo?.data?.showDocuments
                );

                return res;
              }
            );
          })
          .then(() => {
            navigate(`/${encodeURIComponent(countryName)}`);
            setGetLoader(false);
          });
      });
  };

  return (
    <>
      <section className={styles.esimDestination}>
        {getLoader && <MainLoader />}
        <div className="mobBk">
          <div className="container ipdad-cutm">
            <h6>{STRINGS.CONNECT_ANYWHERE}</h6>
            <h3>{STRINGS.INTERNATIONAL_ESIM_DESTINATIONS}</h3>
            <div className={styles.SearchBoxOuter}>
              <div className={styles.SimpleSearch}>
                <span>
                  <img width="20" height="20" src={srchic} alt="" />
                </span>
                <input
                  type="text"
                  placeholder={STRINGS.SEARCH_DESTINATION_PLACEHOLDER}
                  onChange={handleSearchCountries}
                  value={searchVal?.search}
                />
                <button>{STRINGS.SEARCH_BUTTON}</button>
              </div>
              {searchVal?.search &&
                countriesData &&
                (countriesData?.length > 0 ? (
                  <ul className={styles.ContrySearch}>
                    {countriesData?.map((country: any, index: number) => (
                      <li
                        key={index}
                        onClick={() => {
                          setSearchVal({ search: "", submit: false });
                          setCountriesData([]);
                          createOrder(country?.name);
                        }}
                      >
                        <img
                          src={country?.flagImageUrl}
                          alt={country?.name}
                          style={{ width: "30px" }}
                        />
                        {country?.name}
                      </li>
                    ))}
                  </ul>
                ) : (
                  searchVal?.search?.length > 2 && (
                    <ul className={styles.ContrySearch}>
                      <li>
                        {" "}
                        {loader ? (
                          <Spinner animation="grow" variant="light" />
                        ) : (
                          <li>{STRINGS.COUNTRY_NOT_FOUND}</li>
                        )}
                      </li>
                    </ul>
                  )
                ))}
            </div>
          </div>
        </div>

        <div className={styles.esimBlogs}>
          <ul>
            {/* <li
                onClick={() => {
                  if (activeTab !== BUNDLE_TYPE.POPULAR) {
                    setActiveTab(BUNDLE_TYPE.POPULAR);
                    setLoader(false);
                    setSearchVal({
                      search: "",
                      submit: false,
                    });
                    setCurrentPage(1);
                  }
                }}
                className={
                  activeTab === BUNDLE_TYPE.POPULAR ? styles.active : ""
                }
              >
                <span>Popular Plans </span>
              </li> */}

            <li
              onClick={() => {
                if (activeTab !== BUNDLE_TYPE.LOCAL) {
                  setActiveTab(BUNDLE_TYPE.LOCAL);
                  setLoader(false);
                  setSearchVal({
                    search: "",
                    submit: false,
                  });
                  setCurrentPage(1);
                }
              }}
              className={activeTab === BUNDLE_TYPE.LOCAL ? styles.active : ""}
            >
              <span>{STRINGS.LOCAL_ESIMS}</span>
            </li>
            <li
              onClick={() => {
                if (activeTab !== BUNDLE_TYPE.MULTIVERSE) {
                  setActiveTab(BUNDLE_TYPE.MULTIVERSE);
                  setLoader(false);
                  setSearchVal({
                    search: "",
                    submit: false,
                  });
                  setCurrentPage(1);
                }
              }}
              className={
                activeTab === BUNDLE_TYPE.MULTIVERSE ? styles.active : ""
              }
            >
              <span>{STRINGS.REGIONS}</span>
            </li>
          </ul>
        </div>

        <div className="container ipdad-cutm mobile-sims">
          <div className={styles.esimPack}>
            {(activeTab === BUNDLE_TYPE.POPULAR ||
              activeTab === BUNDLE_TYPE.LOCAL) && (
              <>
                <div className="mobHeadings">
                  {/* <h5>
                      Popular Countries
                    </h5> */}
                  {/* <a href="#">View All</a> */}
                </div>

                {/* __ here added loader only other code/functionality is as it is ___ arch*/}

                {/* Search Result (if search input has value and results exist) */}
                {/* {isMobile && searchVal?.search?.length > 2 && (
  <ul className={styles.ContrySearch}>
    {loader ? (
      <li>
        <Spinner animation="grow" variant="light" />
      </li>
    ) : countriesData?.length > 0 ? (
      countriesData.map((country: any, index: number) => (
        <li
          key={index}
          onClick={() => {
            createOrder(country?.name);
            setSearchVal({ search: "", submit: false });
            setCountriesData([]);
          }}
        >
          <img
            src={country?.flagImageUrl}
            alt={country?.name}
            style={{ width: "30px" }}
          />
          {country?.name}
        </li>
      ))
    ) : (
      <li>{STRINGS.COUNTRY_NOT_FOUND}</li>
    )}
  </ul>
)} */}

                {/* Full Country List (always visible) */}
                <div className="row mt-4">
                  {loader ? (
                    <div className="col-md-12 text-center">
                      {isMobile ? (
                        Array.from({ length: 12 }).map((_, index) => (
                          <div className="col-md-2" key={index}>
                            <Skeleton active avatar paragraph={{ rows: 2 }} />
                          </div>
                        ))
                      ) : (
                        <MainLoader />
                      )}
                    </div>
                  ) : getDatas?.countries1?.length > 0 ? (
                    getDatas.countries1.map((item: any, index: number) => (
                      <div
                        className="col-md-3"
                        key={index}
                        onClick={() => createOrder(item?.name)}
                      >
                        <div className={styles.franceBox}>
                          {item?.historicImageUrl && (
                            <img
                              className={styles.taj}
                              style={{ width: "100%", height: "100%" }}
                              src={item?.historicImageUrl}
                              alt=""
                            />
                          )}
                          <span
                            className="d-flex align-items-center"
                            style={{ gap: "10px" }}
                          >
                            {item?.flagImageUrl && (
                              <img
                                className={styles.flagfrnce}
                                width="40"
                                height="40"
                                src={item?.flagImageUrl}
                                alt=""
                              />
                            )}
                            <label>
                              <h4>{item?.name}</h4>
                              <p>
                                From {item?.currencySymbol}{" "}
                                {Number(item?.lowestRetailPrice)?.toFixed(0)}
                              </p>
                            </label>
                          </span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-md-12" style={{ color: "#fff" }}>
                      <h4 style={{ textAlign: "center" }}>
                        {STRINGS.COUNTRY_NOT_FOUND}
                      </h4>
                    </div>
                  )}

                  {/* Pagination only when not searching */}
                  {!searchVal.search?.trim() && (
                    <Pagination
                      count={getDatas?.count}
                      handlePageChange={handlePageChange}
                      currentPage={currentPage}
                      itemsPerPage={pageRecords}
                      loadMore={loadmore}
                    />
                  )}
                </div>
              </>
            )}
            {activeTab === BUNDLE_TYPE.MULTIVERSE && getDatas && (
              <>
                <div className="mobHeadings">
                  <h5>
                    {STRINGS.POPULAR_REGIONS}
                    {/* <a href="#">View All</a> */}
                  </h5>
                </div>
                <div className="row">
                  {getDatas?.regions?.length > 0 ? (
                    getDatas?.regions?.map((item: any, index: number) => (
                      <div
                        className="col-md-3"
                        key={index}
                        onClick={() => createOrder(item?.name)}
                      >
                        <div className={styles.franceBox}>
                          {item?.historicImageUrl && (
                            <img
                              className={styles.taj}
                              width="105"
                              height="104"
                              style={{ width: "100%", height: "100%" }}
                              src={item?.historicImageUrl}
                              alt=""
                            />
                          )}

                          <span
                            className="d-flex align-items-center"
                            style={{ gap: "10px" }}
                          >
                            {item?.flagImageUrl && (
                              <img
                                className={styles.flagfrnce}
                                width="40"
                                height="40"
                                src={item?.flagImageUrl}
                                alt=""
                              />
                            )}

                            <label>
                              <h4>{item?.name}</h4>
                              {/* <p>
                                From {item?.currencySymbol}{" "}
                                {Number(item?.lowestRetailPrice)?.toFixed(0)}
                              </p> */}
                            </label>
                          </span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-md-12" style={{ color: "#fff" }}>
                      <h4 style={{ textAlign: "center" }}>
                        {loader && (
                          <Skeleton active avatar paragraph={{ rows: 2 }} />
                        )}
                      </h4>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
          {isMobile ? (
            <>
              <div className="mobilePurchase">
                <div className="leftMobPur">
                  <h5>{STRINGS.INSTALL_PURCHASED_ESIM}</h5>
                </div>
                <div className="rightmobpur">
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      setShowSomeDropdown({
                        installation: !showSomeDropdown?.installation,
                        deviceCompatibility:
                          showSomeDropdown?.deviceCompatibility &&
                          !showSomeDropdown?.deviceCompatibility,
                      });
                    }}
                  >
                    {STRINGS.INSTALL_GUIDELINES}
                    <i className="fas fa-angle-double-right"></i>
                  </a>
                  {showSomeDropdown?.installation && (
                    <ul>
                      <li>
                        <a
                          href="https://www.youtube.com/shorts/voW6qD5mQKE"
                          target="_blank"
                        >
                          <i className="fab fa-youtube"></i>{" "}
                          {STRINGS.GUIDELINES_FOR_ANDROID}
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.youtube.com/shorts/yJk3lSCnF2Y"
                          target="_blank"
                        >
                          <i className="fab fa-youtube"></i>{" "}
                          {STRINGS.GUIDELINES_FOR_IOS}
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </div>
              <div className="helpdeskMoob">
                <div className="leftdeskmob">
                  <h5> {STRINGS.GO_TO_HELP_DESK}</h5>
                  <h6>{STRINGS.HELP_DESK_SUBTITLE}</h6>
                  <Link to="/contact" target="_blank" rel="noopener noreferrer">
                    {STRINGS.GET_HELP}
                  </Link>
                </div>
                <div className="rightdeskmob">
                  <img src={helpmob} alt="" />
                </div>
              </div>
              <div className="deviceSuport">
                <h5>{STRINGS.CHECK_DEVICE_COMPATIBILITY}</h5>
                <h6>{STRINGS.ENSUR_YOUR_DEVICE}</h6>
                <div className="formGroup">
                  <input
                    type="text"
                    placeholder="Enter your Phone Model"
                    onChange={(e) => {
                      setDeviceName(e.target.value);
                    }}
                    value={deviceName}
                  />
                  <button onClick={handelCompatibleDevice}>
                    {STRINGS.ESIM_APPLY}
                  </button>
                </div>
              </div>
            </>
          ) : (
            false
          )}
          {isMobile
            ? getMobDatas && (
                <div className="mobileSims">
                  <h4>{STRINGS.POPULAR_PLAN_REGION}</h4>
                  <div className={styles.esimPackMob}>
                    <div className="row">
                      {/* <SearchBar searchClass={styles.topSearch} placeHolder={"Search Country, Regions, eSIM"} handleSearchSubmit={handleSearchSubmit} viewAllBundle={viewAllBundle} /> */}
                      {getMobDatas?.bundles?.length > 0 ? (
                        getMobDatas?.bundles.map(
                          (bundle: any, index: number) => (
                            <div className="col-md-3" key={index}>
                              <div className={styles.esimpackLeft}>
                                <div className={styles.PackList}>
                                  <div className="homepckCard">
                                    <BundleCard bundle={bundle} />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        )
                      ) : (
                        <span className="text-center" style={{ color: "#fff" }}>
                          {STRINGS.ESIM_PLANE_NOT_FOUND}
                        </span>
                      )}
                      <Pagination
                        count={getMobDatas?.count} // You can replace this with the actual count received from the API
                        handlePageChange={handlePageChange}
                        currentPage={currentPage}
                        itemsPerPage={pageRecords}
                        loadMore={loadmore}
                        loader={loader}
                      />
                    </div>
                  </div>
                </div>
              )
            : false}
        </div>
        <div className={styles.Installation_unleashed}>
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <div className={styles.Showcase_esim}>
                  <span>
                    <h1>Enjoy the advantages of <br/>the Commbitz app</h1>
                    <ul className="py-4">
                      <li>Use your favorite apps as soon as you land.</li>
                      <li>Access the best local networks.</li>
                      <li>Share your connection across all your devices.</li>
                      <li>Track your usage and get alerts to top up.</li>
                    </ul>
                    <button
                      className="text-white border p-2"
                      onClick={() =>
                        window.open(
                          "https://commbitz.com/commbitz-app",
                          "_blank"
                        )
                      }
                    >
                      Download App
                    </button>
                  </span>
                </div>
              </div>
         
              <div className="col-md-4 d-flex justify-content-center position-relative">
                <label className={styles.airplane}><img className="w-100" src={airplane} alt={"airplane"} /></label>
                <img className="w-100" src={eSIM} alt={"eSIM"} />
              </div>
            </div>
          </div>
        </div>

        <div className="container Installation_Guide my-5">
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <div className={styles.left_section}>
                <h1 className="my-4">Installation Guide</h1>
                <div className={styles.buttons_group}>
                  <button
                    className={selectedPlatform === "ios" ? styles.active : ""}
                    onClick={() => setSelectedPlatform("ios")}
                  >
                    <img className="me-2" src={forios} alt={"forios"} />
                    For iOS
                  </button>
                  <button
                    className={
                      selectedPlatform === "android" ? styles.active : ""
                    }
                    onClick={() => setSelectedPlatform("android")}
                  >
                    <img className="me-2" src={forandroid} alt={"forandroid"} />
                    For Android
                  </button>
                </div>
                <h5 className="my-4">How to Install Commbitz eSIM in iOS?</h5>
                <div className="steps">
                  <div
                    className="step d-flex align-items-center mb-4"
                    style={{ gap: "15px" }}
                  >
                    <div className={styles.step_number}>
                      <h6 className="mb-0">Step</h6>
                      <h4 className="mb-0">01</h4>
                    </div>
                    <div className={styles.step_mobile}>
                      <h4 className="mb-0">Open Settings</h4>
                      <span>Open settings and look for Mobile Services</span>
                    </div>
                  </div>
                  <div
                    className="step d-flex align-items-center mb-4"
                    style={{ gap: "15px" }}
                  >
                    <div className={styles.step_number}>
                      <h6 className="mb-0">Step</h6>
                      <h4 className="mb-0">02</h4>
                    </div>
                    <div className={styles.step_mobile}>
                      <h4 className="mb-0">Go to Cellular</h4>
                      <span>In mobile Services see Add eSIM</span>
                    </div>
                  </div>
                  <div
                    className="step d-flex align-items-center mb-4"
                    style={{ gap: "15px" }}
                  >
                    <div className={styles.step_number}>
                      <h6 className="mb-0">Step</h6>
                      <h4 className="mb-0">03</h4>
                    </div>
                    <div className={styles.step_mobile}>
                      <h4 className="mb-0">Set Up Cellular</h4>
                      <span>In setup mobile service USE QR code</span>
                    </div>
                  </div>
                  <div
                    className="step d-flex align-items-center mb-4"
                    style={{ gap: "15px" }}
                  >
                    <div className={styles.step_number}>
                      <h6 className="mb-0">Step</h6>
                      <h4 className="mb-0">04</h4>
                    </div>
                    <div className={styles.step_mobile}>
                      <h4 className="mb-0">Open Photos</h4>
                      <span>Open photos and look scan QR code of the esim</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className={styles.right_section}>
                  <div className={styles.groupanimation}> 

                  <a
                  href={
                    selectedPlatform === "ios"
                      ? "https://www.youtube.com/shorts/yJk3lSCnF2Y"
                      : "https://www.youtube.com/shorts/voW6qD5mQKE"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                      <div className={styles.circleButton}>
                        <img className={styles.outer} src={outer} alt={"Rotating Ring"} />
                        <img className={styles.center} src={inner} alt={"Play Button"} />
                      </div>
                    </a>
                  <img style={{ width: '80%' }} src={guide} alt={"Guide"} />
               </div>
              </div>
            </div>
          </div>
        </div>
        {/* {welcomeModalShow && (
          <WelcomeBanner
            show={welcomeModalShow}
            handleCloseModal={showWelcomeModalShow}
          />
        )} */}
      </section>

      <section className={styles.esimDestination}>
        {getLoader && <MainLoader />}
        {/* <div className="mobBk">
          <div className="container ipdad-cutm">
            <h3>Enjoy mobile internet in over 190 destinations</h3>
            <h6 className="py-2">
              Sost Brilliant reasons Entrada should be your one-stop-shop!
            </h6>

            {!isMobile &&
              searchVal?.search &&
              countriesData &&
              (countriesData?.length > 0 ? (
                <ul className={styles.ContrySearch}>
                  {countriesData?.map((country: any, index: number) => (
                    <li
                      key={index}
                      onClick={() => {
                        // setSearchVal({
                        //   ...searchVal,
                        //   search: country?.name,
                        // });
                        // setCountriesData("");
                        createOrder(country?.name);
                      }}
                    >
                      <img
                        src={country?.flagImageUrl}
                        alt={country?.name}
                        style={{ width: "30px" }}
                      />
                      {country?.name}
                    </li>
                  ))}
                </ul>
              ) : (
                searchVal?.search?.length > 2 && (
                  <ul className={styles.ContrySearch}>
                    <li>
                      {" "}
                      {loader ? (
                        <Spinner animation="grow" variant="light" />
                      ) : (
                        <li>{STRINGS.COUNTRY_NOT_FOUND}</li>
                      )}
                    </li>
                  </ul>
                )
              ))}
          </div>
        </div> */}

        {/* <div className={styles.destinations}>
          <ul className="my-4">
            <li
                onClick={() => {
                  if (activeTab !== BUNDLE_TYPE.POPULAR) {
                    setActiveTab(BUNDLE_TYPE.POPULAR);
                    setLoader(false);
                    setSearchVal({
                      search: "",
                      submit: false,
                    });
                    setCurrentPage(1);
                  }
                }}
                className={
                  activeTab === BUNDLE_TYPE.POPULAR ? styles.active : ""
                }
              >
                <span>Popular Plans </span>
              </li>

            <li
              onClick={() => {
                if (activeTab !== BUNDLE_TYPE.LOCAL) {
                  setActiveTab(BUNDLE_TYPE.LOCAL);
                  setLoader(false);
                  setSearchVal({
                    search: "",
                    submit: false,
                  });
                  setCurrentPage(1);
                }
              }}
              className={activeTab === BUNDLE_TYPE.LOCAL ? styles.active : ""}
            >
              <span>London</span>
            </li>
            <li
              onClick={() => {
                if (activeTab !== BUNDLE_TYPE.MULTIVERSE) {
                  setActiveTab(BUNDLE_TYPE.MULTIVERSE);
                  setLoader(false);
                  setSearchVal({
                    search: "",
                    submit: false,
                  });
                  setCurrentPage(1);
                }
              }}
              className={
                activeTab === BUNDLE_TYPE.MULTIVERSE ? styles.active : ""
              }
            >
              <span>Bangkok</span>
            </li>
            <li
              onClick={() => {
                if (activeTab !== BUNDLE_TYPE.MULTIVERSE) {
                  setActiveTab(BUNDLE_TYPE.MULTIVERSE);
                  setLoader(false);
                  setSearchVal({
                    search: "",
                    submit: false,
                  });
                  setCurrentPage(1);
                }
              }}
              className={
                activeTab === BUNDLE_TYPE.MULTIVERSE ? styles.active : ""
              }
            >
              <span>England</span>
            </li>

            <li
              onClick={() => {
                if (activeTab !== BUNDLE_TYPE.MULTIVERSE) {
                  setActiveTab(BUNDLE_TYPE.MULTIVERSE);
                  setLoader(false);
                  setSearchVal({
                    search: "",
                    submit: false,
                  });
                  setCurrentPage(1);
                }
              }}
              className={
                activeTab === BUNDLE_TYPE.MULTIVERSE ? styles.active : ""
              }
            >
              <span>Singapore</span>
            </li>

            <li
              onClick={() => {
                if (activeTab !== BUNDLE_TYPE.MULTIVERSE) {
                  setActiveTab(BUNDLE_TYPE.MULTIVERSE);
                  setLoader(false);
                  setSearchVal({
                    search: "",
                    submit: false,
                  });
                  setCurrentPage(1);
                }
              }}
              className={
                activeTab === BUNDLE_TYPE.MULTIVERSE ? styles.active : ""
              }
            >
              <span>Italy</span>
            </li>
          </ul>
        </div> */}
 <div className={styles.Assistant}>
        <div className="container">
          <div className={styles.php_phnappleft}>
            <div className="row">
              <div className="col-md-6">
                {/* Tabs */}
                <ul
                  className={`d-flex gap-5 mb-4 w-75 ${styles.tabs_ConnectAI}`}
                  // style={{ borderBottom: "1px solid #C5AFC9" }}
                >
                  {["ConnectAI"].map((tab) => (
                    <li
                      key={tab}
                      className={`fw-semibold ${
                        selectedTab === tab ? "text-black pb-1" : ""
                      }`}
                      style={{
                        cursor: "pointer",
                        color: selectedTab !== tab ? "#C5AFC9" : undefined,
                      }}
                      onClick={() => setSelectedTab(tab)}
                    >
                      {tab}
                    </li>
                  ))}
                </ul>

                {/* Content */}
                {selectedTab === "ConnectAI" && (
                  <div>
                    <h1 className="fw-bold mb-3 text-dark">
                      Your <span style={{ color: "black" }}>24/7 AI eSIM</span>
                      <br />
                      Assistant
                    </h1>
                    <p className="text-light-emphasis mb-4">
                      Your smart travel companion that makes eSIM setup <br />
                      and support effortless.
                    </p>
                    <ul className="list-unstyled">
                      <li className="d-flex align-items-center mb-3">
                        <span className="me-2">✔</span>
                        <span>Choose the Best Plan for You</span>
                      </li>
                      <li className="d-flex align-items-center mb-3">
                        <span className="me-2">✔</span>
                        <span>Guides You Through Installation</span>
                      </li>
                      <li className="d-flex align-items-center">
                        <span className="me-2">✔</span>
                        <span>24/7 Support in 35+ Languages</span>
                      </li>
                    </ul>
                    <div className="d-flex justify-content-end">
                        <img className={`w-25 ${styles.robotFloat}`} src={robot} alt="Robot" />
                    </div>
              
                  </div>
                  
                )}

                {selectedTab === "Travel Mate" && (
                  <div>
                    <h1 className="fw-bold mb-3 text-dark">
                      Your Personalized Travel Planner
                    </h1>
                    <p className="text-light-emphasis mb-4">
                      Discover curated itineraries, travel tips, and experiences
                      tailored for you.
                    </p>
                  </div>
                )}

                {selectedTab === "CBZ Coin" && (
                  <div>
                    <h1 className="fw-bold mb-3 text-dark">
                      CBZ Coin Rewards Program
                    </h1>
                    <p className="text-light-emphasis mb-4">
                      Earn and redeem coins for discounts, free data, and
                      exclusive perks.
                    </p>
                  </div>
                )}
                
              </div>
              
              <div className="col-md-6">
                <img className="w-100" src={travelmate} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
        <div className="container my-5">
          <h3>Enjoy mobile internet in over 190 destinations</h3>
          <h6 className="py-3">
            {/* { Sost Brilliant reasons Entrada should be your one-stop-shop!} */}
          </h6>
          <div className={styles.gridcontainer}>
            <div className={styles.card}>
              { <div className={styles.rating}>3.5</div>}
              <img className="position-absolute w-100" src={londoneye} alt="" />
              <div className={styles.content}>
                <div className={styles.title}>London</div>
                <div className={styles.subtitle}>London Eye</div>
              </div>
            </div>

            <div className={`${styles.card} ${styles.tall}`}>
              { <div className={styles.rating}>4.0</div> }
              <img
                className="position-absolute w-100 h-100"
                src={amalficoast}
                alt=""
                style={{ objectFit: "cover" }}
              />
              <div className={styles.content}>
                <div className={styles.title}>Italy</div>
                <div className={styles.subtitle}>Amalfi Coast</div>
              </div>
            </div>

            <div className={`${styles.card} ${styles.wide}`}>
              { <div className={styles.rating}>4.2</div> }
              <img
                className="position-absolute w-100"
                src={Lakezurich}
                alt=""
              />
              <div className={styles.content}>
                <div className={styles.title}>Switzerland </div>
                <div className={styles.subtitle}>Lake Zurich</div>
              </div>
            </div>

            <div className={styles.card}>
              { <div className={styles.rating}>3.8</div> }
              <img
                className="position-absolute w-100"
                src={MerlionPark}
                alt=""
              />
              <div className={styles.content}>
                <div className={styles.title}>Singapore</div>
                <div className={styles.subtitle}>Merlion Park</div>
              </div>
            </div>

            <div className={styles.card}>
              { <div className={styles.rating}>3.9</div> }

              <img
                className="position-absolute w-100"
                src={eiffeltower}
                alt=""
              />
              <div className={styles.content}>
                <div className={styles.title}>France</div>
                <div className={styles.subtitle}>Eiffel Tower</div>
              </div>
            </div>

            <div className={styles.card}>
              { <div className={styles.rating}>4.1</div> }
              <img className="position-absolute w-100" src={Halongbay} alt="" />
              <div className={styles.content}>
                <div className={styles.title}>Vietnam</div>
                <div className={styles.subtitle}>Hạ Long Bay</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EsimDestination;
